import {useCallback, useEffect} from 'react';
import {ONBOARDING_EXPRESS_ORDER_COMPLETION_KEY} from 'modules/onboarding/constants/steps';
import {useNextStep} from 'nextstepjs';
import {useIsMobileByScreen} from 'core/hooks/useIsMobileByScreen';
import {useRouter} from 'next/router';
import {APP_ROUTES_TO_URL} from 'core/modules/routing/constants';

export const useInitOnboarding = (isActive: boolean) => {
    const {startNextStep} = useNextStep();
    const isMobile = useIsMobileByScreen();
    const router = useRouter();
    const handleStartTour = useCallback(() => {
        startNextStep('mainTour');
        try {
            localStorage.setItem(ONBOARDING_EXPRESS_ORDER_COMPLETION_KEY, 'true');
        } catch (e) {
            console.error('LocalStorage недоступен:', e);
        }
    }, [startNextStep]);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;
        let innerTimeoutId: NodeJS.Timeout;

        const checkPath = () => {
            return (
                ('/' === router.pathname ||
                    router.pathname.includes(APP_ROUTES_TO_URL.catalog) ||
                    router.pathname.includes(APP_ROUTES_TO_URL.search)) &&
                !router.pathname.includes('/catalog/product')
            );
        };

        if (isActive && checkPath()) {
            timeoutId = setTimeout(() => {
                try {
                    if (!localStorage.getItem(ONBOARDING_EXPRESS_ORDER_COMPLETION_KEY)) {
                        const resolution = isMobile ? 'MOBILE' : 'DESKTOP';
                        const expressOrderPopupButton = document.querySelector(
                            `[data-tooltip-id='EXPRESS_ORDER_TOOLTIP_${resolution}']`,
                        ) as HTMLElement;
                        expressOrderPopupButton?.click();

                        innerTimeoutId = setTimeout(() => handleStartTour(), 100);
                    }
                } catch (e) {
                    console.error('LocalStorage недоступен:', e);
                }
            }, 300);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (innerTimeoutId) {
                clearTimeout(innerTimeoutId);
            }
        };
    }, [isActive, handleStartTour, isMobile, router.pathname]);
};
